import React, { useEffect, useState } from "react";
import {
  FaPlus,
  FaEllipsisVertical,
  FaEye,
  FaPen,
  FaCopy,
  FaFilter,
} from "react-icons/fa6";
import { MdDelete, MdSearch, MdRefresh } from "react-icons/md";
import { handleRowsPerPage } from "../../../controls/Pagination/Pagination";
import { capitalizeWords } from "../../../../utils/common";

import { Header, DataTable } from "../../../common";
import {
  ButtonView,
  CardView,
  Input,
  Select,
  ModalView,
  IconMenuOption,
} from "../../../controls";

import "./TransactionHistoryStyles.scss";

const TransactionHistoryView = ({
  paymentReceiptList,
  notificationTypeList,
  //
  currentPageOfTransactionHistory,
  rowsPerPageOfTransactionHistory,
  persistedData,
  //
  rowsPerPageDropDownOptions,
  //
  handleTableRowsChange,
  handleChangePage,
  //
  fetchPaymentReceipts,
  //
  onClickNotificationTypeMenuFilterOptions,
}) => {
  // console.log("paymentReceiptList", paymentReceiptList);

  const renderNotificationTypeHeader = (label) => {
    return (
      <div className="custom-column-header">
        <text>{label}</text>
        <div className="sortIcon">
          {
            <IconMenuOption
              menuIcon={<FaFilter />}
              options={notificationTypeList}
              name={"type"} //access the value using this prop in iconMenuOption
              search={false} //show search input
              showMenuOptions={true}
              onClickFilterOption={onClickNotificationTypeMenuFilterOptions}
              persistedData={persistedData?.notificationType}
            />
          }
        </div>
        {/* )} */}
      </div>
    );
  };

  const renderOriginalTransactionValue = (row) => {
    const transactionId = row?.receiptInfo?.originalTransactionId;
    const handleCopy = (transactionId) => {
      if (transactionId) {
        navigator.clipboard
          .writeText(transactionId)
          .then(() => {
            console.log("Transaction ID copied to clipboard!"); // Optional feedback for the user
          })
          .catch((err) => {
            console.error("Could not copy text: ", err);
          });
      }
    };

    return (
      <div className="cell-wrapper">
        <span data-tag="allowRowEvents" className={`content-block`}>
          {row?.receiptInfo?.originalTransactionId || "-"}
        </span>
        <span className="action-block">
          <FaCopy
            size={15}
            title="Copy"
            onClick={() => handleCopy(transactionId)}
          />
        </span>
      </div>
    );
  };

  const columns = [
    {
      name: "Original Transaction ID",
      cell: (row) => renderOriginalTransactionValue(row),
      grow: 1.5,
    },
    {
      name: renderNotificationTypeHeader("Notification Type"),
      selector: (row) => row?.notificationType || "-",
      grow: 1,
    },
    {
      name: "Sub Type",
      selector: (row) => row?.notificationType || "-",
      grow: 1,
    },
    {
      name: "Product ID",
      selector: (row) => row?.receiptInfo?.productId || "-",
      grow: 1,
    },
    {
      name: "Price",
      selector: (row) => row?.receiptInfo?.price || "-",
      grow: 1,
    },
    {
      name: "Environment",
      selector: (row) => row?.receiptInfo?.environment || "-",
      grow: 1,
    },
  ];

  return (
    <div className="subscription__management--container">
      <div className="subscription__management--header-wrapper">
        <div className="title-content">Subscription Management</div>
        <div className="action-btn-wrapper">
          {/* {userPermissions?.includes("add_user") && ( */}
          {/* <ButtonView
            title="Refresh"
            styles={"secondary"}
            icon={<MdRefresh size={20} />}
            onClick={() => fetchPaymentReceipts()}
          /> */}
          {/* )} */}
        </div>
      </div>
      <div className="subscription__management--table-wrapper">
        <div className="controls-wrapper">
          <div className="row-control-wrapper">
            <Select
              value={rowsPerPageOfTransactionHistory}
              placeholder={10}
              options={rowsPerPageDropDownOptions}
              onChange={(val) => {
                handleTableRowsChange(val);
              }}
              isRowCap={true}
            />{" "}
            entries per page
          </div>
          <div className="row-control-wrapper">
            <ButtonView
              title="Refresh"
              styles={"secondary"}
              icon={<MdRefresh size={20} />}
              onClick={() => {
                const refresh = true;
                fetchPaymentReceipts(undefined, undefined, refresh);
              }}
            />
          </div>
        </div>
        <div className="table-content">
          <DataTable
            columns={columns}
            data={paymentReceiptList?.docs || []}
            highlightOnHover={true}
            pointerOnHover={true}
            fixedHeader={true}
            persistTableHead={true}
            //
            pagination={true}
            paginationServer={true}
            paginationPerPage={paymentReceiptList?.limit}
            paginationTotalRows={paymentReceiptList?.totalDocs}
            onChangeRowsPerPage={handleTableRowsChange}
            onChangePage={handleChangePage}
            currentPage={currentPageOfTransactionHistory}
            //
          />
        </div>
      </div>
    </div>
  );
};

export default TransactionHistoryView;
